import {createSelector} from "reselect";
import {isLoadingDealers} from "./dealers";
import {isLoadingIvsVin} from "./ivsCallCenterResults";
import {isLoadingSelectedDealer} from "./customerDealer";

export const isLoading = createSelector(isLoadingDealers, isLoadingIvsVin, isLoadingSelectedDealer, (...args) => args.some(Boolean));
